/**
 * Telefon rasmi (4000×3000, 3–8 MB) yuklashdan oldin kichraytiriladi.
 *
 * Mobil internetda 8 MB li yozma ish rasmi daqiqalab yuklanadi va imtihon
 * vaqtini yeydi. 2000 px — qoʻlyozma hali bemalol oʻqiladigan chegara;
 * JPEG 0,82 bilan odatda 300–700 KB chiqadi.
 *
 * Har qanday xatoda (eski brauzer, buzilgan fayl) — asl fayl qaytadi:
 * siqish yaxshilanish, u yuklashni toʻxtatib qoʻymasligi kerak.
 */
const MAX_SIDE = 2000;
const QUALITY = 0.82;
/** Bundan kichik va oʻlchami meʼyorida boʻlsa — tegmaymiz. */
const SMALL_ENOUGH = 700 * 1024;

const COMPRESSIBLE = ['image/jpeg', 'image/png', 'image/webp'];

export async function compressImage(file: File): Promise<File> {
  if (!COMPRESSIBLE.includes(file.type)) return file;
  try {
    // `from-image` — EXIF boʻyicha buradi, aks holda telefon rasmi yonboshlab qoladi.
    const bitmap = await createImageBitmap(file, {
      imageOrientation: 'from-image',
    });
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    if (scale === 1 && file.size <= SMALL_ENOUGH) {
      bitmap.close();
      return file;
    }
    const width = Math.round(bitmap.width * scale);
    const height = Math.round(bitmap.height * scale);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      bitmap.close();
      return file;
    }
    // PNG shaffof joylari JPEG da qora boʻlib qolmasin.
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(bitmap, 0, 0, width, height);
    bitmap.close();

    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', QUALITY),
    );
    if (!blob || blob.size >= file.size) return file;
    const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], name, {
      type: 'image/jpeg',
      lastModified: file.lastModified,
    });
  } catch {
    return file;
  }
}
